import { getLocale } from "../runtime";

const sv_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Lägsta priset de senaste 30 dagarna: ${inputs.price}`
};

const lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_lowestpricelast30days(inputs)
	return "lowestPriceLast30Days";
};

export { lowestpricelast30days as "lowestPriceLast30Days" };